export const STATE_NAME = "error";
export const UNIQUE_CONSTRAINT_ERROR = "UniqueConstraintFailed";
export const EXISTING_EIN_ERROR = "UniqueConstraintFailed";
